import { Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { DeviceStatus } from '../../../business/model/homelan/deviceStatus.view-model';

@Component({
    selector: 'device-status',
    templateUrl: 'device-status.html',
    standalone: true,
    imports: [TranslateModule],
})
export class DeviceStatusComponent {
    public deviceStatus = input<DeviceStatus>();
    public loadingStatus = computed((): boolean => !this.deviceStatus()?.id);
}
